import naja from 'naja';
import CookiesPolicy from '../classes/cookies-policy';

export default function initCookiesPolicy() {
  CookiesPolicy.init();
}

naja.addEventListener('init', initCookiesPolicy);
